import { QueryClient } from '@tanstack/react-query';

import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import { type IQueryState } from '../IQueryState';

import { QueryState } from './QueryState';

export class BrowserQueryState extends QueryState implements IQueryState {
  public constructor(applicationContext: IQueryStateAppContext) {
    const { config } = applicationContext;

    const queryClient = new QueryClient({
      defaultOptions: { queries: { refetchOnMount: false, refetchOnWindowFocus: false } },
    });

    super(queryClient);

    this.hydrate(config.getStrict<unknown>(QueryState.key));
  }
}
